module.exports = __webpack_public_path__ + "common/icon-x-mark-6ccccde35366af36f5988936777cc906.svg";